module.exports = __webpack_public_path__ + "static/media/straw_hat.e4210640.png";